export default {"src":"/_next/static/media/rank-icon-dark.029d18b7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};